import { useNavigate } from 'react-router-dom-v5-compat'

import { useIsSplitEnabled } from '@buffer-mono/features'
import { BetaBadge, Button, CoachMark } from '@buffer-mono/popcorn'

import { useDismissableBanner } from '~publish/hooks/useDismissableBanner'
import { selectIsManagerInChannel } from '~publish/legacy/profile-sidebar/selectors'
import { useAppSelector } from '~publish/legacy/store'
import { useSelectedChannel } from '~publish/pages/Channel/ChannelContext'

import { BULK_UPLOAD_EXCLUDED_SERVICES } from './BulkPostSetting'

export const BulkPostCoachmark = ({
  children,
}: {
  children: React.ReactNode
}): JSX.Element => {
  const navigate = useNavigate()
  const channel = useSelectedChannel()
  const isManager: boolean = useAppSelector(
    selectIsManagerInChannel(channel?.id),
  )
  const canUseBulkPostUpload =
    channel &&
    isManager &&
    !BULK_UPLOAD_EXCLUDED_SERVICES.includes(channel?.service)
  const isBulkUploadEnabled = useIsSplitEnabled('bulk-post-upload-csv')
  const { isActive: isCoachMarkActive, dismiss: dismissBanner } =
    useDismissableBanner('bulk-post-upload-csv', {
      trackDismiss: true,
    })

  const shouldShowCoachMark =
    isBulkUploadEnabled && canUseBulkPostUpload && isCoachMarkActive
  if (!shouldShowCoachMark) return <>{children}</>

  return (
    <CoachMark onDismiss={dismissBanner}>
      <CoachMark.Overlay>
        {children}
        <CoachMark.Spotlight />
      </CoachMark.Overlay>
      <CoachMark.Content>
        <CoachMark.Title>
          <BetaBadge /> Bulk Post Upload
        </CoachMark.Title>
        <CoachMark.Description>
          Save time and schedule or save up all your posts in one go.
        </CoachMark.Description>
        <CoachMark.Footer>
          <CoachMark.Dismiss>
            <Button variant="secondary">Not now</Button>
          </CoachMark.Dismiss>
          <CoachMark.Dismiss>
            <Button
              onClick={() => {
                navigate('settings?tab=general&bulkUploads=true')
              }}
            >
              Check it out
            </Button>
          </CoachMark.Dismiss>
        </CoachMark.Footer>
      </CoachMark.Content>
    </CoachMark>
  )
}
